export default {
  layout: {
    expandMenu: true
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js